import { app } from '../app/app.js';
import { navigation } from '../app/navigation.js';
import { listenToEvent, listenToEventSync } from '../util/listen_to_event.js';
import { window } from '../window.js';
import { ControlsBar } from './controls_bar.js';
import { LocSearchControl } from './locsearch_control.js';

import '../controls/popup_button_control.js';

/**
 * Maps search autocomplete control.
 */
class MapsSearchControl extends LocSearchControl {
  initialize() {
    super.initialize();

    this.leftButtonsElement.innerHTML = `
      <popup-button-control class='autocomplete-menu-button'
                            name='Menu'
                            img='/images/map-button-menu.png'
                            hidden></popup-button-control>
    `;

    this.rightButtonsElement.innerHTML = `
      <div class='autocomplete-newloc-button'>
        <img class='autocomplete-button' title='Add a location'
             src='/images/map-button-new.png'
             onclick='window.map_addLocation();'>
      </div>
      <form target='loc-search-file-iframe' hidden
            action='/api/upload'
            method='post' enctype='multipart/form-data'>
        <label for='loc-search-file'>
          <img class='autocomplete-button' title='Share media or GPS track'
               src='/images/map-button-upload.png'>
        </label>
        <input type='file' id='loc-search-file' name='files' hidden
               onchange='this.parentNode.submit();'>
        <iframe name='loc-search-file-iframe' hidden></iframe>
      </form>
      <label class='place-media-on-map-button'
             for='place-media-on-map'>
        <img class='autocomplete-button'
             title='Upload pictures'
             src='/images/map-button-upload.png'>
        <input id='place-media-on-map' type='file' hidden
               multiple>
      </label>
      </div>
      <div class='autocomplete-close-button' hidden>
        <img class='autocomplete-button' title='Close the maps'
             src='/images/map-button-close.png'>
      </div>
    `;

    this.menu.setItems(this.constructor.menuitems);
    this.menu.addEventListener(
      'itemselect',
      ev => ev.detail && ev.detail.onselect(ev)
    );

    listenToEventSync(this.placeMediaOnMapButton, 'click', ev =>
      app.authenticatePreventDefaultIfAuthNeeded(ev)
    );
    listenToEvent(this.closeButton, 'click', () => navigation.closeMap());

    for (let fileInput of [
      this.placeMediaOnMapFileInput,
      this.inMenuPlaceMediaOnMapFileInput,
    ]) {
      fileInput.addEventListener('change', ev =>
        navigation.map.addMedia(ev.target.files)
      );
    }
  }

  /**
   * Closes an open popup if any. Returns false if no popup was closed.
   */
  closeIfOpen() {
    if (this.open || this.menu.open) {
      this.open = false;
      this.menu.open = false;
      return true;
    }
    return false;
  }

  // Switch maps popup button.
  static get menuitems() {
    return [
      {
        img: '/images/map-button-fullscreen-in.png',
        name: 'Fullscreen',
        title: 'Fullscreen',
        type: 'fullscreen',
        onselect() {
          window.toggleFullscreen(this);
        },
      },
    ]
      .concat([
        {
          img: '/images/map-button-geography.png',
          name: 'Map types',
          class: 'popup-list-group',
          onselect() {
            // no action for a group
          },
        },
      ])
      .concat(
        ControlsBar.mapTypeItems.map(i =>
          Object.assign(
            {
              class: 'popup-list-subitem',
            },
            i
          )
        )
      )
      .concat([
        {
          img: '/images/map-filter.png',
          name: 'Filter locations',
          class: 'popup-list-group',
          onselect() {
            // no action for a group
          },
        },
      ])
      .concat(
        ControlsBar.locTypeItems.map(i =>
          Object.assign(
            {
              class: 'popup-list-subitem',
            },
            i
          )
        )
      )
      .concat([
        {
          img: '/images/map-button-new.png',
          name: 'Add location',
          class: 'popup-list-group',
          title: 'Add location',
          type: 'add-loc',
          onselect() {
            window.map_addLocation();
          },
        },
        {
          markup: `
          <label class='popup-list-item'
                 for='inmenu-place-media-on-map'
                 title='Upload pictures'>
            <img src='/images/map-button-upload.png'>
            <span class='popup-list-item-text'>Upload pictures</span>
            <input id='inmenu-place-media-on-map' type='file' hidden
                   multiple>
          </label>
        `,
          type: 'upload-pic',
          onselect: ev => app.authenticatePreventDefaultIfAuthNeeded(ev),
        },
      ]);
  }

  static get selectors() {
    const selectors = super.selectors;
    const Menu = `${selectors.LeftButtons} .autocomplete-menu-button`;
    return Object.assign({}, selectors, {
      CloseButton: `.autocomplete-close-button`,
      Menu,
      InMenuPlaceMediaOnMapMenuitem: `${Menu} label[for='inmenu-place-media-on-map']`,
      InMenuPlaceMediaOnMapFileInput: `${Menu} #inmenu-place-media-on-map`,
      PlaceMediaOnMapButton: `${selectors.RightButtons} .place-media-on-map-button`,
      PlaceMediaOnMapFileInput: `${selectors.RightButtons} #place-media-on-map`,
    });
  }

  static elements = {
    closeButton: this.selectors.CloseButton,
    menu: this.selectors.Menu,
    inMenuPlaceMediaOnMapFileInput:
      this.selectors.InMenuPlaceMediaOnMapFileInput,
    placeMediaOnMapButton: this.selectors.PlaceMediaOnMapButton,
    placeMediaOnMapFileInput: this.selectors.PlaceMediaOnMapFileInput,
  };
}

window.customElements.define('mapsearch-control', MapsSearchControl);

export { MapsSearchControl };
